// extracted by mini-css-extract-plugin
export default {"wr":"FiscalCheck_wr__ya0FW","input":"FiscalCheck_input__Uw4Gg","error":"FiscalCheck_error__A7FIN","pop_up__btn":"FiscalCheck_pop_up__btn__XQ+rW"};